import styled from 'styled-components';

import { theme } from '../../ui/theme';

export const AttachmentGrid = styled.div`
    display: grid;
    grid-template-rows: min-content 1fr min-content;
    grid-template-columns: 24px 1fr min-content;
    width: 100%;
    column-gap: ${theme.space[8]};
    margin-bottom: ${theme.space[16]};

    &:last-child {
        margin: 0;
    }
`;
